import { useContext } from 'react';
import { context } from '../providers/AuthProvider';

export const useAzureAD = () => {
	return useContext(context);
};